export const messages = {
  'teams.badges.subtree': 'Subárvore: {count}',
  'teams.collapse': 'Recolher {name}',
  'teams.expand': 'Expandir {name}',
  'teams.subteams': 'Sub-equipes de {name}',
  'teams.loading': 'Carregando estrutura...',
  'teams.error': 'Erro ao carregar estrutura da campanha.',
  'teams.empty.title': 'Sem estrutura',
  'teams.empty.description': 'Nenhuma equipe ou nível cadastrado nesta campanha.',
  'teams.title': 'Equipes',

  // Equipes screen (Teams.tsx)
  'teams.nav.label': 'Equipes',
  'teams.view.cards': 'Cards',
  'teams.view.tree': 'Árvore',
  'teams.list.levels.label': 'Níveis da campanha',
  'teams.list.empty.title': 'Nenhuma equipe ainda',
  'teams.list.empty.description': 'Uma equipe aparece aqui assim que for criada em um nível.',
  'teams.accounts.one': '{count} conta',
  'teams.accounts.other': '{count} contas',

  // Cards tab (Teams.tsx, TeamCard.tsx, LevelSummary.tsx)
  'teams.cards.label': 'Hierarquia de equipes',
  'teams.unassigned.link.one': '{count} conta sem equipe',
  'teams.unassigned.link.other': '{count} contas sem equipe',
  'teams.card.lead.label': 'Responsável',
  'teams.card.figure.members': 'Integrantes',
  'teams.card.figure.reach': 'Alcance',
  'teams.card.figure.posts': 'Publicações',
  'teams.card.figure.sentiment': 'Variação de sentimento',
  'teams.card.lead.hint': 'quem responde pela equipe',
  'teams.card.figure.members.hint': 'contas monitoradas nesta equipe e nas equipes dentro dela',
  'teams.card.figure.reach.hint': 'ainda sem fonte de dados, por isso aparece vazio',
  'teams.card.figure.posts.hint': 'publicações das contas desta equipe e das equipes dentro dela',
  'teams.card.figure.sentiment.hint':
    'apoio menos hostilidade nos comentários dos últimos 7 dias, comparado aos 7 anteriores',
  'teams.card.accounts.label': 'Contas de {name}',
  'teams.card.accounts.loading': 'Carregando contas...',
  'teams.card.accounts.error': 'Erro ao carregar contas.',

  // Blocked state (NoStructure.tsx)
  'teams.blocked.title': 'Organize as contas por equipe',
  'teams.blocked.description':
    'Veja alcance, publicações e sentimento somados por gerência, regional ou comunidade.',

  // Structure presets (StructurePresets.tsx; Figma 329:12603)
  'teams.presets.groupLabel': 'Modelo de estrutura',
  'teams.presets.action': 'Usar esta estrutura',
  'teams.presets.scratch.title': 'Montar do zero',
  'teams.presets.scratch.description': 'Você define cada nível',
  'teams.presets.levelCount.one': '{count} nível',
  'teams.presets.levelCount.other': '{count} níveis',
  'teams.presets.level.manager': 'Gerente',
  'teams.presets.level.regional': 'Regional',
  'teams.presets.level.community': 'Comunidade',
  'teams.presets.level.coordination': 'Coordenação',
  'teams.presets.level.neighborhood': 'Bairro',

  // Structure dialog (StructureDialog.tsx, Structure.tsx; Figma 325:11801, 678:20157)
  'teams.editor.trigger': 'Estrutura',
  'teams.editor.title': 'Estrutura de equipes',
  'teams.editor.addLevel': 'Adicionar nível',
  'teams.editor.level.name.label': 'Nome do nível',
  'teams.editor.removeLevel': 'Remover nível',
  'teams.editor.undoRemoveLevel': 'Desfazer',
  'teams.editor.level.teamCount.one': '{count} equipe',
  'teams.editor.level.teamCount.other': '{count} equipes',
  'teams.editor.save': 'Salvar estrutura',
  'teams.editor.saving': 'Salvando…',
  'teams.editor.saved': 'Estrutura salva',
  'teams.editor.save.failed': 'Não deu para salvar. Tente de novo.',
  'teams.editor.consequence.label': 'Ao salvar:',
  'teams.editor.consequence.teamsRemoved.one': '{count} equipe deixa de existir.',
  'teams.editor.consequence.teamsRemoved.other': '{count} equipes deixam de existir.',
  'teams.editor.consequence.accountsMoved.one': '{count} conta sobe um nível.',
  'teams.editor.consequence.accountsMoved.other': '{count} contas sobem um nível.',
  'teams.editor.consequence.accountsUnassigned.one': '{count} conta fica sem equipe.',
  'teams.editor.consequence.accountsUnassigned.other': '{count} contas ficam sem equipe.',

  // New-team dialog (NewTeam.tsx, ParentPicker.tsx, LeadPicker.tsx)
  'teams.newTeam.title': 'Nova equipe',
  'teams.newTeam.name.label': 'Nome da equipe',
  'teams.newTeam.name.required': 'Informe o nome da equipe',
  'teams.newTeam.submit': 'Criar equipe',

  'teams.newTeam.parent.label': 'Dentro de',
  'teams.newTeam.parent.placeholder': 'Escolha onde a equipe fica',
  'teams.newTeam.parent.required': 'Escolha onde a equipe fica.',
  'teams.newTeam.parent.searchPlaceholder': 'Buscar equipe',
  'teams.newTeam.parent.empty': 'Nenhuma equipe encontrada',
  'teams.newTeam.parent.top': 'Sem equipe acima',
  'teams.newTeam.parent.topGroup': 'No topo · cria {level}',
  'teams.newTeam.parent.group': '{level} · cria {next}',
  'teams.newTeam.parent.derivedLevel': 'Cria uma equipe de nível',

  'teams.newTeam.lead.label': 'Responsável',
  'teams.newTeam.lead.placeholder': 'Buscar responsável',
  'teams.newTeam.lead.searchPlaceholder': 'Buscar responsável por nome ou @',
  'teams.newTeam.lead.group': 'Contas monitoradas',
  'teams.newTeam.lead.empty': 'Nenhuma conta monitorada com esse nome.',
  'teams.newTeam.lead.useNameOnly': 'Usar "{name}" sem conta monitorada',
  'teams.newTeam.lead.remove': 'Remover responsável "{name}"',

  // Team "⋯" menu (TeamActions.tsx)
  'teams.actions.label': 'Ações de {name}',
  'teams.actions.newTeamIn': 'Adicionar equipe em {name}',
  'teams.actions.edit': 'Editar equipe',
  'teams.actions.accounts': 'Adicionar conta',
  'teams.actions.remove': 'Remover equipe',
  'teams.remove.title': 'Remover {name}?',
  'teams.remove.description':
    'As contas desta equipe ficam sem equipe. Uma equipe com equipes dentro dela não pode ser removida.',
  'teams.remove.confirm': 'Remover equipe',

  // Edit-team dialog (EditTeam.tsx)
  'teams.editTeam.title': 'Editar equipe',
  'teams.editTeam.submit': 'Salvar',
  'teams.editTeam.level.label': 'Nível',
  'teams.editTeam.moveSubtree.label': 'Vai junto para {name}:',
  'teams.editTeam.moveSubtree.teams.one': '{count} equipe',
  'teams.editTeam.moveSubtree.teams.other': '{count} equipes',
  'teams.editTeam.failed': 'Não deu para salvar. Tente de novo.',

  // Team accounts dialog (TeamAccounts.tsx)
  'teams.accountsDialog.title': 'Contas de {name}',
  'teams.accountsDialog.searchPlaceholder': 'Buscar conta',
  'teams.accountsDialog.searchEmpty': 'Nenhuma conta encontrada.',
  'teams.accountsDialog.elsewhere': 'em {team}',
  'teams.accountsDialog.elsewhereUnknown': 'outra equipe',
  'teams.accountsDialog.unassigned': 'sem equipe',
  'teams.accountsDialog.count.one': '{count} conta nesta equipe',
  'teams.accountsDialog.count.other': '{count} contas nesta equipe',
  'teams.accountsDialog.empty': 'Nenhuma conta nesta equipe ainda.',
  'teams.accountsDialog.remove': 'Tirar {name} da equipe',
  'teams.accountsDialog.moveFailed': 'Não deu para mover. Tente de novo.',
  'teams.accountsDialog.done': 'Concluir',
};
